<template>
  <el-table
    class="table-container"
    :class="[
      styleType === 2 ? 'table-container-en' : '',
      device.isMobile ? 'table-container-mobile' : '',
    ]"
    :data="tableData"
    border
    style="width: 100%"
    :stripe="styleType === 2 ? true : false"
  >
    <el-table-column v-for="(item, index) in headerData" :prop="item.prop" :label="item.label" :key="index" :width="item.width * rem" align="center">
      <template slot-scope="scope">
        <textIndex v-if="scope.row[item.prop].type === 'text'" :content="scope.row[item.prop]" :isInTable="true"></textIndex>
        <div
          v-else-if="scope.row[item.prop].type === 'input'"
          :ref="scope.row[item.prop].key"
          class="table-input"
          contenteditable
        ></div>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
/*
单个表格组件
*/
import textIndex from "../text/index.vue";
export default {
  name: "table-single",
  components: {
    textIndex,
  },
  props: {
    styleType: {
      type: Number,
      default: 1,
    },
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    headerData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      rem: 0,
    }
  },
  mounted() {
    this.initRem()
  },
  methods: {
    initRem() {
      let width = window.document.documentElement.getBoundingClientRect().width;
      if (!this.device.isMobile) {
        width = 750;
      }else{
        width = width > 750 ? 750 : width;
      }
      this.rem = width / 750; // 将屏幕宽度分为10份， 1份为1rem
    },
    reset() {
      // console.log(this.$refs)
      let refs = this.$refs;
      for(let i in refs) {
        let refDiv = refs[i][0];
        refDiv.innerHTML = '';
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.table-container{
  .table-input{
    text-align: left;
    font-size: 26rem;
    line-height: 1.2;
    color: #1A1A1A;
  }
  /deep/.cell{
    line-height: 1.2;
  }
  /deep/th.el-table__cell{
    background: #4B96D1;
    color: #fff;
    font-size: 16rem;
    line-height: 1.2;
    font-weight: normal;
    border-bottom: 1rem solid #68A7D9 !important;
    border-right: 1rem solid #68A7D9;
  }
  /deep/.el-table__body .el-table__cell {
    padding: 16rem 0;
    border-bottom: 1rem solid #68A7D9;
    border-right: 1rem solid #68A7D9;
    background: rgba(255,255,255,0.7);
    .text-container{
      font-size: 16rem;
    }
    .pop-font{
      span{
        font-size: 16rem;
      }
    }
  }
  /deep/.el-table--border {
    border: 1rem solid #4B96D1;
  }
  /deep/.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
    background: rgba(255,255,255,0.7);
  }
  /deep/.el-table--group{
    border: 1rem solid #4B96D1;
  }
  .el-table--group, .el-table--border {
    border: 1rem solid #4B96D1;
  }
  /deep/th.el-table__cell.is-leaf, 
  td.el-table__cell {
    border-bottom: 1rem solid #4B96D1;
  }
  /deep/.el-table--border .el-table__cell {
    border-right: 1rem solid #4B96D1;
    font-size: 16rem;
  }
}
.table-container.table-container-en{
  border-radius: 10rem;
  border: 1rem solid #7FBA9E;
  /deep/th.el-table__cell{
    background: #5CA683;
    color: #fff;
    font-weight: normal;
    border-bottom: 1rem solid #5CA683 !important;
    border-right: 1rem solid #7FBA9E;
    font-style: italic;
    height: 80rem;
    min-height: 80rem;
    .cell{
      font-size: 26rem;
      line-height: 1.2;
    }
  }
  /deep/.el-table__body  {
    .el-table__cell{
      padding: 16rem 0;
      border-bottom: 0;
      border-right: 1rem solid #7FBA9E;
      background: #fff;
      height: 93rem;
      min-height: 93rem;
      .cell{
        span{
          font-size: inherit;
          line-height: inherit;
        }
      }
    }
    .el-table__row--striped{
      .el-table__cell{
        background: #D2E3D9;
      }
    }
    .text-container{
      font-size: 16rem;
    }
    .pop-font{
      span{
        font-size: 16rem;
      }
    }
  }
  /deep/.el-table--border {
    border: 1rem solid #5CA683;
  }
  /deep/.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
    background: #D2E3D9;
  }
  /deep/.el-table--group{
    border: 1rem solid #5CA683;
  }
  .el-table--group, .el-table--border {
    border: 1rem solid #5CA683;
  }
  /deep/th.el-table__cell.is-leaf, 
  td.el-table__cell {
    border-bottom: 1rem solid #5CA683;
  }
  /deep/.el-table--border .el-table__cell {
    border-right: 1rem solid #5CA683;
    font-size: 16rem;
  }
}
.table-container.table-container-mobile{
  /deep/th.el-table__cell{
    font-size: 24rem;
  }
  /deep/.el-table__body .el-table__cell {
    padding: 16rem 0;
    .cell{
      padding: 0 10rem;
    }
    .text-container{
      font-size: 24rem;
      line-height: 1.2;
    }
    .pop-font{
      span{
        font-size: 24rem;
        line-height: 1.2;
      }
    }
  }
  /deep/.el-table--border .el-table__cell {
    font-size: 20rem;
  }
}
</style>